import { useFormik } from 'formik';
import { UserValidation } from '@/validations';

export interface InitValues {
  username: string;
  password: string;
  captchaText: string;
  remember: boolean;
}

export function useFormLogin(onSubmit: (values: InitValues, helpers: any) => void) {
  const formik = useFormik<InitValues>({
    onSubmit,
    validateOnMount: true,
    validationSchema: UserValidation.login,
    initialValues: {
      username: '',
      password: '',
      captchaText:'',
      remember: false
    },
  });
  return formik;
}

export default useFormLogin;
